<script setup>
import { ref, defineProps, defineEmits } from 'vue';

defineProps(['resultsCount', 'page', 'totalPages']);

const emit = defineEmits(['search', 'prevPage', 'nextPage']);

const searchInput = ref('');

const handleSearchInput = () => {
  if (searchInput.value === '') {
    emit('search', '');
  }
};
</script>

<template>
  <div class="section-card">
    <div class="section-card-header">
      <h2>
        <slot/>
      </h2>
      <div class="search-bar">
        <input
          type="search"
          v-model="searchInput"
          @input="handleSearchInput"
          @keyup.enter="$emit('search', searchInput)">
        <button @click="$emit('search', searchInput)" class="btn-green">Szukaj</button>
      </div>
    </div>

    <div class="toolbar-row">
      <div class="results-chip">Wyniki: <b>{{ resultsCount || 0 }}</b></div>
      <div class="pagination">
        <button class="btn-outline" @click="$emit('prevPage')" :disabled="page <= 1">
          &#8592; Poprzednia
        </button>
        <span class="page-info">Strona {{ page }} / {{ totalPages }}</span>
        <button class="btn-outline" @click="$emit('nextPage')" :disabled="page >= totalPages">
          Następna &#8594;
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.search-bar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.search-bar input {
  flex: 1 1 240px;
  min-width: 0;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 1.5rem;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.search-bar input:focus {
  border-color: #10b981;
}

.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.results-chip {
  font-size: 1.4rem;
  color: #374151;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 6px 12px;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.page-info {
  font-size: 1.5rem;
  color: #6b7280;
  font-weight: 500;
  min-width: 130px;
  text-align: center;
}

.empty-state {
  text-align: center;
  padding: 28px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.5rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 900px) {
  .toolbar-row {
    flex-direction: column;
    align-items: stretch;
  }

  .pagination {
    justify-content: space-between;
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .toolbar-row {
    flex-direction: column;
    align-items: stretch;
  }

  .pagination {
    justify-content: space-between;
  }

  .search-bar input {
    flex: auto;
  }
}

@media (max-width: 480px) {
  .search-bar {
    flex-direction: column;
  }

  .search-bar input,
  .btn-primary,
  .btn-green,
  .btn-outline {
    width: 100%;
  }
}
</style>